import styled from 'styled-components';
import { createGradientOrSolid } from '../../Helper/utils/utils';
import { breakpoints } from '../../../styles/breakpoints';

export const StyledProductMadnessBundle = styled.div`
    --secondary-text-color: #f89fbc;

    &.jackpot-slots-bundle {
        font-family: var(--font-family);
        background: var(--bundle-border-color);
        padding: 2px;
        border-radius: 7px;

        .products {
            background: ${(props: any) =>
                props.backgroundSrc
                    ? `url("${props.backgroundSrc}")`
                    : createGradientOrSolid(props.backgroundColor)};
            background-size: 100% 100%;
            height: 74px;
            display: flex;
            flex-direction: column;
            position: relative;
            padding: 2px 7px 2px 2px;
            border: 1px solid white;
            border-radius: 7px;

            @media (min-width: 425px) {
                height: 94px;
            }

            .main-product {
                width: 100%;
                height: 45px;
                display: flex;
                justify-content: space-between;

                @media (min-width: 425px) {
                    height: 60px;
                }

                &__header {
                    &__prefix-img {
                        height: 18px;
                        width: 18px;
                    }
                }

                .main-product-placeholder {
                    min-height: 50px;
                    min-width: 50px;
                }
            }

            .sub-items {
                flex: 1;
            }
        }

        .jackpot-slots-bundle__container {
            display: flex;
            flex-direction: column;
            height: 100%;
            position: relative;
        }

        .jackpot-slots-bundle__emblem-badge {
            position: absolute;
            top: 42px;
            left: -7px;
            background-image: url(${(props: any) => props.badgeImage});
            background-repeat: no-repeat;
            z-index: 1000;
            height: 32px;

            @media (width <= ${breakpoints.mobileM}) {
                top: 32px;
                height: 28px;
            }

            img {
                max-height: 100%;
            }
        }

        .main-product {
            display: flex;
            align-items: center;
            width: 100%;
        }
    }

    .scroller {
        > button {
            width: 12px;
            height: 12px;
            border-radius: 100%;
            border: 0;
            position: relative;
            background: var(--secondary-text-color);
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 8px;

            &:hover {
                cursor: pointer;
            }
        }
    }

    .sub-items__prefix-text {
        color: var(--secondary-text-color);
        font-size: 12px;
        font-weight: 600;
        margin-left: 8px;
        margin-right: 4px;
    }

    .sub-items-grid {
        display: flex;
        overflow: hidden;
        padding: 2px;
        max-height: 24px;

        > div {
            display: flex;
            white-space: nowrap;
            justify-content: center;
            align-items: center;
            padding: 0;
            margin: 0;
        }
    }
` as any;

export const StyledMainProduct = styled.div`
  display: flex;
  align-items: center;

  img {
    object-fit: contain;

    &.mainPic {
      height: 48px;
      width: 48px;
      padding-left: 8px;
      padding-top: 4px;
    }

    &.prefixPic {
      height: 18px;
      width: 18px;
    }
  }

  .main-product__header {
    max-width: calc(100% - 75px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: baseline;
    position: relative;
    margin-left: 4px;

    .quantity {
      margin: unset;
      font-weight: 700;
      background: linear-gradient(180deg, #FDEC00 0%, #E7AC06 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      position: relative;
      font-size: 20px;
      
      @media (width < ${breakpoints.mobileS}) {
        font-size: 16px;
      }

      &:after {
        background: none;
        content: '${(props: any) => props.title}';
        left: 0;
        top: 0;
        z-index: -1;
        position: absolute;
        text-shadow: 0 2px 0px #000000;
      }
    }

    p {
      margin: 0;
      text-align: center;

      &.stroked {
        font-size: 12px;
        font-weight: 500;
        letter-spacing: 1px;
        color: var(--secondary-text-color);
        position: relative;
        text-shadow: 0 2px black;
        padding: 0 2px;

        &::after {
          content: ' ';
          height: 2px;
          width: 100%;
          background: var(--secondary-text-color);
          position: absolute;
          left: 0;
          top: 50%;
        }
      }
    }
  }

  @media (min-width: 425px) {
    img {
      &.mainPic {
        height: 64px;
        width: 64px;
      }

      &.prefixPic {
        height: 22px;
        width: 22px;
      }
    }

    .text {
      max-width: calc(100% - 95px);
    }
  }
` as any;

export const StyledSubProduct = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    margin: 0 5px;

    .sub-product {
        &__container {
            height: 100%;
            display: flex;
            align-items: center;
        }

        &__text {
            font-size: 12px;
            font-weight: 600;
            color: white;
        }

        &__image {
            aspect-ratio: 1/1;
            object-fit: contain;
            height: 16px;
            margin-right: 2px;
        }
    }

    @media (min-width: 375px) {
        .product-image-container .tooltip {
            height: 10px;
            width: 10px;
        }
    }
` as any;
